<p-card header="Lista użytkowników">
  <app-table
    [config]="config"
    [customCellTemplateRef]="customCellTemplateRef" />

  <ng-template
    #customCellTemplateRef
    let-column="column"
    let-model="model">
    <app-user-list-custom-cell-template
      [column]="column"
      [model]="model" />
  </ng-template>
</p-card>
